import { useSelector } from 'react-redux';
import { AppState } from 'src/models/AppState';
import { SessionState } from './SessionState';

export function useSession(): SessionState {
    return useSelector((state: AppState) => state.session);
}
